//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link, NavLink } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'
import { AuthContext } from '../context/auth-context'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../components/UIElements/SearchByLeagueOrVenue'
import Banner from '../../shared/components/Navigation/Banner'
import sLogo from '../../images/s_logo_png.png'
import Arsenal from '../../images/Arsenal.png'
import BarrieKingsmen from '../../images/Barrie-kingsmen.png'
import ChicagoSouthsiders from '../../images/Chicago Southsiders.png'
import Dekheads from '../../images/Dekheads.png'
import Gods from '../../images/Gods.png'
import Graffix from '../../images/Graffix.png'
import Indians from '../../images/Indians.png'
import MidnightExpress from '../../images/Midnight Express.png'
import NightsWatch from '../../images/Nights Watch.png'
import NorthsideMilitia from '../../images/Northside Militia.png'
import PurplePower from '../../images/Purple Power.png'
import RoseCityRoyals from '../../images/Rose City Royals.png'
import Warriors from '../../images/Warriors.png'
import USA from '../../images/USA-logo.png'
import JrGods from '../../images/Team Pittsburgh Jr. Gods.png'
import Raptors from '../../images/Riverview Raptors.jpeg'
import Americans from '../../images/Americans.png'

const DivisionSchedule = () => {
	console.log('inside DivisionSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allDivisionGames, setAllDivisionGames] = useState([])

	const divisionName = useParams().divisionName
	const leagueId = useParams().leagueId
	const divisionId = useParams().divisionId

	const auth = useContext(AuthContext)

	/* console.log('divisionName: ' + divisionName)
	console.log('leagueId: ' + leagueId)
	console.log('divisionId: ' + divisionId) */

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	//Get all games scheduled for this division.  league-controller  getDivisionSchedule
	useEffect(() => {
		//
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			setAllDivisionGames([])
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/div/${divisionName}/${leagueId}/${divisionId}/schedule`,
				)

				const responseData = await response.json()

				console.log('division games: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}
				setAllDivisionGames(responseData.allDivisionGamesArray)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [divisionId])
	//
	//
	//console.log('allLeagueGames: ' + JSON.stringify(allLeagueGames))
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	const teamLogoMap = {
		'Penn Hills Arsenal': Arsenal,
		'Barrie Kingsmen': BarrieKingsmen,
		'Chicago Southsiders': ChicagoSouthsiders,
		'Iowa Dekheads': Dekheads,
		'Pittsburgh Gods': Gods,
		'Graffix Ball Hockey Club': Graffix,
		'Garden State Indians': Indians,
		'Brampton Midnight Express': MidnightExpress,
		"South Jersey Night's Watch": NightsWatch,
		'South Jersey Night’s Watch': NightsWatch,
		'Northside Militia': NorthsideMilitia,
		'Pittsburgh Purple Power': PurplePower,
		'Rose City Royals': RoseCityRoyals,
		'Garden State Warriors': Warriors,
		'USA Legends': USA,
		'Leominster Americans': Americans,
		'Pittsburgh Jr. Gods': JrGods,
		'Riverview Raptors': Raptors,
	}

	const getTeamLogo = (teamName) => teamLogoMap[teamName]

	const getDisplayScore = (game) => {
		if (!game.score) return ''
		return `${game.score}${game.scoreSuffix ? ` ${game.scoreSuffix}` : ''}`
	}

	const getFormattedDate = (game) => {
		const month = game.date.substr(0, 2)
		const day = game.date.substr(3, 2)

		const monthMap = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${monthMap[month]} ${day}`
	}

	const getFormattedTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minutes = game.time.substr(3, 2)

		const hourMap = {
			'00': '12',
			'01': '1',
			'02': '2',
			'03': '3',
			'04': '4',
			'05': '5',
			'06': '6',
			'07': '7',
			'08': '8',
			'09': '9',
			10: '10',
			11: '11',
			12: '12',
			13: '1',
			14: '2',
			15: '3',
			16: '4',
			17: '5',
			18: '6',
			19: '7',
			20: '8',
			21: '9',
			22: '10',
			23: '11',
			24: '12',
		}

		const suffix = Number(hour) < 12 || hour === '24' ? 'AM' : 'PM'

		return `${hourMap[hour]}:${minutes} ${suffix}`
	}

	const getWinningTeamClass = (game, team) => {
		if (!game.score) return ''

		const isWinner =
			(team === 'home' && game.winner === game.homeTeamId) ||
			(team === 'visitor' && game.winner === game.visitorTeamId)

		if (!isWinner) return ''

		const isPlayoff = game.playoff || game.championship || game.description

		return isPlayoff
			? 'mobileWinningTeam mobileWinningTeamPlayoff'
			: 'mobileWinningTeam'
	}

	const renderMobileScheduleCards = (games = []) => {
		return (
			<div className='mobileGameCards'>
				{games.map((game, key) => {
					const homeLogo = getTeamLogo(game.homeTeamName)
					const visitorLogo = getTeamLogo(game.visitorTeamName)
					const divisionLabel = game.playoff
						? game.playoffDivision
						: game.divisionName

					return (
						<div
							className={`mobileGameCard ${
								game.playoff || game.championship || game.description
									? 'mobileGameCardPlayoff'
									: ''
							}`}
							key={key}
						>
							<div className='mobileGameCardHeader'>
								<div>{getFormattedDate(game)}</div>

								<div className='mobileGameDivisionHeader'>
									<span>{divisionLabel}</span>

									{game.description && (
										<span className='mobileGameDescription'>
											{game.description}
										</span>
									)}
								</div>

								<div>{getFormattedTime(game)}</div>
							</div>

							<div className='mobileGameCardBody'>
								<div className='mobileGameTeam'>
									{homeLogo && <img src={homeLogo} alt={game.homeTeamName} />}
									<div className={getWinningTeamClass(game, 'home')}>
										{game.homeTeamAbbreviation || game.homeTeamName}
									</div>
								</div>

								{game.score ? (
									<Link
										className='mobileGameScore'
										to={`/gameSummary/${game._id}`}
									>
										{getDisplayScore(game)}
										<span>Final</span>
									</Link>
								) : (
									<div className='mobileGameScore mobileGameScoreEmpty'>
										<span>TBP</span>
									</div>
								)}

								<div className='mobileGameTeam'>
									{visitorLogo && (
										<img src={visitorLogo} alt={game.visitorTeamName} />
									)}
									<div className={getWinningTeamClass(game, 'visitor')}>
										{game.visitorTeamAbbreviation || game.visitorTeamName}
									</div>
								</div>
							</div>

							<div className='mobileGameVenue'>📍 {game.venueName}</div>
						</div>
					)
				})}
			</div>
		)
	}
	//
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && allDivisionGames.length === 0) {
		return (
			<React.Fragment>
				{/* <AdminNavigation /> */}
				<SchedulesHomeNavigation />
				{!isMobile && (
					<div style={{ marginTop: '5rem' }}>
						<Banner />
					</div>
				)}
				<SearchByLeagueOrVenue />
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (!isLoading && allDivisionGames.length !== 0) {
		// distinctVenuesArray.forEach((venue) => {
		//allLeagueGames.forEach((game) => {
		dateBlock.push(
			<div className='Schedule' style={{ marginTop: '1rem' }}>
				{/* <AdminNavigation /> */}
				{/* <h1>Schedule</h1> */}
				{isMobile && (
					<div className='divisionScheduleHero'>
						<div className='standingsHeroTop'>
							<div className='standingsHeroLine'></div>

							<div className='standingsHeroLogoCircle'>
								<img src={sLogo} alt='Shirey logo' />
							</div>

							<div className='standingsHeroLine'></div>
						</div>

						<h1>
							{divisionName}
							<br />
							<span>Division Schedule</span>
						</h1>

						<div className='divisionScheduleHero__pill'>
							{allDivisionGames[0].year} {allDivisionGames[0].leagueName}
						</div>

						<p>Click on the final score of a game to see a Game Summary</p>
					</div>
				)}
				{!isMobile && (
					<div className='divisionScheduleDesktopHeader'>
						<h1>{divisionName}</h1>

						<h2>
							{allDivisionGames[0].year} {allDivisionGames[0].leagueName}
						</h2>

						<p>Click on the final score of a game to see a Game Summary</p>
					</div>
				)}
				{/* <SearchByLeagueOrVenue /> */}
				{isMobile ? (
					renderMobileScheduleCards(allDivisionGames)
				) : (
					<table id='defaultScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time</th>
								<th>Rink</th>
								{/* <th>Division</th> */}
								<th>Visitor/Home</th>
								<th></th>
								{auth.isLoggedIn && <th></th>}
								<th>Winner</th>
								<th>Score</th>
								{/* <th>Venue</th> */}
							</tr>
						</thead>
						<tbody>
							{allDivisionGames.map((game, key) => {
								// if (game.venueName === venue) {
								return (
									<tr key={key}>
										<td>
											{game.dayOfWeek}
											{', '}
											{game.date.substr(0, 2) === '01' &&
												'Jan. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '02' &&
												'Feb. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '03' &&
												'Mar. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '04' &&
												'Apr. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '05' &&
												'May ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '06' &&
												'June ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '07' &&
												'July ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '08' &&
												'Aug. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '09' &&
												'Sept. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '10' &&
												'Oct. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '11' &&
												'Nov. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '12' &&
												'Dec. ' + game.date.substr(3, 2)}
											{/* <br className='mobile-break'></br> at{' '} */}
											<br></br>
											{game.time.substr(0, 2) === '00' &&
												'12:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '01' &&
												'1:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '02' &&
												'2:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '03' &&
												'3:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '04' &&
												'4:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '05' &&
												'5:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '06' &&
												'6:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '07' &&
												'7:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '08' &&
												'8:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '09' &&
												'9:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '10' &&
												'10:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '11' &&
												'11:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '12' &&
												'12:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '13' &&
												'1:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '14' &&
												'2:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '15' &&
												'3:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '16' &&
												'4:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '17' &&
												'5:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '18' &&
												'6:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '19' &&
												'7:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '20' &&
												'8:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '21' &&
												'9:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '22' &&
												'10:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '23' &&
												'11:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '24' &&
												'12:' + game.time.substr(3, 2) + ' am'}
										</td>
										<td>{game.venueName}</td>

										{game.visitorTeamName && !isMobile && (
											<td>
												{game.visitorTeamSeed > 0 &&
													'(' + game.visitorTeamSeed + ') '}
												{game.visitorTeamName && game.visitorTeamName}
												<br></br>
												{' @ '}
												<br></br>
												{game.homeTeamSeed > 0 &&
													'(' + game.homeTeamSeed + ') '}
												{game.homeTeamName && game.homeTeamName}
												{game.description && (
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{'('}
														{game.description}
														{')'}
													</div>
												)}
											</td>
										)}
										{/* //
											//
											//  Show team abbreviations if in mobile view
											//
											// */}
										{game.visitorTeamName && isMobile && (
											<td>
												{game.visitorTeamSeed > 0 &&
													'(' + game.visitorTeamSeed + ') '}
												{game.visitorTeamAbbreviation || game.visitorTeamName}
												<br></br>
												{' @ '}
												<br></br>
												{game.homeTeamSeed > 0 &&
													'(' + game.homeTeamSeed + ') '}
												{game.homeTeamAbbreviation || game.homeTeamName}
												{game.description && (
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{'('}
														{game.description}
														{')'}
													</div>
												)}
											</td>
										)}
										{game.eventName && (
											<td
												style={{
													fontWeight: 'bold',
													backgroundColor: 'pink',
												}}
											>
												{game.eventName}
											</td>
										)}
										{game.description && <td></td>}
										{!game.playoff && !game.championship && <td></td>}
										{/* {game.playoff && (
										<td style={{ color: 'red', fontWeight: 'bold' }}>
											{game.description}
										</td>
									)} */}

										{game.championship && (
											<td style={{ color: 'red', fontWeight: 'bold' }}>
												CHAMPIONSHIP GAME
											</td>
										)}
										{auth.isLoggedIn && (
											<td>
												{game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													(game.homeTeamName === 'TBD' ||
														game.visitorTeamName === 'TBD') && (
														<NavLink
															className='navlinksEnterTeams'
															to={`/admin/updateGame/${game._id}`}
															exact
														>
															TEAMS
														</NavLink>
													)}
											</td>
										)}
										{!isMobile &&
											game.homeTeamId &&
											game.winner === game.homeTeamId && (
												<td>{game.homeTeamName}</td>
											)}
										{!isMobile &&
											game.visitorTeamId &&
											game.winner === game.visitorTeamId && (
												<td>{game.visitorTeamName}</td>
											)}
										{isMobile &&
											game.homeTeamId &&
											game.winner === game.homeTeamId && (
												<td>
													{game.homeTeamAbbreviation || game.homeTeamName}
												</td>
											)}
										{isMobile &&
											game.visitorTeamId &&
											game.winner === game.visitorTeamId && (
												<td>
													{game.visitorTeamAbbreviation || game.visitorTeamName}
												</td>
											)}
										{game.status &&
											game.status !== 'TBP' &&
											game.winner !== game.homeTeamId &&
											game.winner !== game.visitorTeamId && <td>TIE</td>}
										{!game.score && <td></td>}
										<td>
											{game.score && (
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'black',
													}}
													to={`/gameSummary/${game._id}`}
												>
													{game.score}
													<span style={{ color: 'black', fontWeight: 'bold' }}>
														{game.scoreSuffix}
													</span>
												</Link>
											)}
										</td>
									</tr>
								)
								//}
							})}
						</tbody>
					</table>
				)}
			</div>,
		)
		// }
		//)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation leagueId={leagueId} />
				{!isMobile && (
					<div style={{ marginTop: '5rem' }}>
						<Banner />
					</div>
				)}
				<div style={{ marginTop: '5rem' }}>
					<SearchByLeagueOrVenue />
				</div>
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default DivisionSchedule
